import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import _ from 'lodash';

import { Text, Box, Link } from '@nerdwallet/currency';

import heroBreadcrumbsTrackingCheck from '~/client/lib/company-content-src/hero-breadcrumb-tracking-check';

import {
  CAREERS_PATH,
  CAREERS_TEAMS_PATH,
} from '~/client/lib/employee-branding/careers-breadcrumbs-paths';

import styles from './hero.module.less';

const ARIA_PAGE = 'page';

const CareersBreadcrumbs = ({
  level,
  careerBreadcrumbDepartment,
  jobTitle,
  location: routerLocation,
}) => {
  const careersTeamPath = `/careers/${_.kebabCase(careerBreadcrumbDepartment)}`;

  const carrot = (
    <div className={styles.careerBreadcrumbCarrot}>
      &nbsp;&gt;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
  );
  const crumbCareers = (
    <Link
      href={heroBreadcrumbsTrackingCheck(CAREERS_PATH, routerLocation.search)}
      className={styles.careerBreadcrumbInline}
    >
      Careers
    </Link>
  );
  const crumbTeams = (
    <Link
      href={heroBreadcrumbsTrackingCheck(
        CAREERS_TEAMS_PATH,
        routerLocation.search
      )}
      className={styles.careerBreadcrumbInline}
    >
      Teams
    </Link>
  );
  const levelOneNav = (
    <React.Fragment>
      {crumbCareers}
      {carrot}
      <Link
        color="neutral-darkest"
        aria-current={level === '1' && ARIA_PAGE}
        className={styles.careerBreadcrumbInline}
      >
        Teams
      </Link>
    </React.Fragment>
  );
  const levelTwoNav = (
    <React.Fragment>
      {crumbCareers}
      {carrot}
      {crumbTeams}
      {carrot}
      <Link
        color="neutral-darkest"
        aria-current={level === '2' && ARIA_PAGE}
        className={styles.careerBreadcrumbInline}
      >
        {careerBreadcrumbDepartment}
      </Link>
    </React.Fragment>
  );
  const levelThreeNav = (
    <React.Fragment>
      {crumbCareers}
      {carrot}
      {crumbTeams}
      {carrot}
      <Link
        href={heroBreadcrumbsTrackingCheck(
          careersTeamPath,
          routerLocation.search
        )}
        className={styles.careerBreadcrumbInline}
      >
        {careerBreadcrumbDepartment}
      </Link>
      {carrot}
      <Link
        color="neutral-darkest"
        aria-current={level === '3' && ARIA_PAGE}
        className={styles.careerBreadcrumbInline}
      >
        {jobTitle}
      </Link>
    </React.Fragment>
  );

  return (
    <Box
      role="navigation"
      aria-label="breadcrumbs"
      className={styles.careerBreadcrumb}
    >
      <Text size="small">
        {level === '1' && levelOneNav}
        {level === '2' && levelTwoNav}
        {level === '3' && levelThreeNav}
      </Text>
    </Box>
  );
};

CareersBreadcrumbs.propTypes = {
  level: PropTypes.string,
  careerBreadcrumbDepartment: PropTypes.string,
  jobTitle: PropTypes.string,
  location: PropTypes.object,
};

CareersBreadcrumbs.displayName = 'CareersBreadcrumbs';

const CareersBreadcrumbsWithRouter = withRouter(CareersBreadcrumbs);

export default CareersBreadcrumbsWithRouter;
